import React, { useContext, useEffect, useRef, useState } from "react";
import CustomTable from "../CustomTable/CustomTable";
import { useLocation, useNavigate } from "react-router-dom";
import { getApi, PostApi } from "../../../Utility/network";
import { Button, InputAdornment, TextField } from "@mui/material";
import dayjs from "dayjs";
import CustomPagination from "../../CustomPagination/CustomPagination";
import { stringToYYYYMMDD } from "../../../Utility/helper";
import CustomSelectChip from "../../CustomSelectItem/CustomSelectItem";
import SearchIcon from "@mui/icons-material/Search";
import {
  EngTableHeads,
  GermTableHeads,
  threeYearsBack,
} from "../../../Pages/Consumption/utility/utils";
import DateField from "../../DateField/DateField";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import { consumptionEngText, consumptionGermText } from "../../Pannel/Pannel";
import { conertDate } from "../../../Utility/utils";

function NeedCertificateTable() {
  const { state, setState, formData, setFormData, pageState, setPageState } =
    useContext(AppContext);
  const { stepLanguage, language } = state;
  const navigate = useNavigate();

  // const [pageState, setPageState] = useState(1);
  // const [formData, setFormData] = useState({
  //   form_status: [],
  //   payment_status: [],
  //   add_service: [],
  //   start_date: stringToYYYYMMDD(
  //     new Date(new Date().setMonth(new Date().getMonth() - 1))
  //   ),
  //   end_date: stringToYYYYMMDD(new Date()),
  //   search: "",
  //   certificate_status: [],
  // });
  const [payment, setPayment] = useState([
    { id: 1, title: "Pending", german_title: "Ausstehend " },
    { id: 2, title: "Paid", german_title: " Bezahlt" },
    { id: 3, title: "Unpaid", german_title: "Unbezahlt" },
    {
      id: 4,
      title: "No Payment Required",
      german_title: "Keine Zahlung erforderlich",
    },
  ]);
  const [form, setForm] = useState([
    { id: 1, title: "Draft", german_title: "Entwurf " },
    { id: 2, title: "Submitted", german_title: "Eingereicht" },
    { id: 3, title: "Not Submitted", german_title: " Nicht eingereicht" },
  ]);
  const [certificate_status, setCertificate_status] = useState([
    { id: 1, title: "Draft", german_title: "Entwurf" },
    { id: 2, title: "Issued", german_title: "Ausgestellt" },
    {
      id: 3,
      title: "Correction Pending",
      german_title: "Berichtigung anhängig",
    },
    { id: 4, title: "Issued Version 2", german_title: "Ausgegebene Version 2" },
  ]);
  const [service, setService] = useState([]);
  const [paginationData, setPaginationData] = useState({});
  const { pageable, page, previous_page, pageNumber, max_pages, pageSize } =
    paginationData;
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState([]);

  const getData = async (filter) => {
    try {
      const responseData = await PostApi(
        `energy_need/user_energy_need/custom_listing/`,
        filter
      );

      setPaginationData(responseData?.data);
      let list = responseData.data.data;
      list = list.map((item, index) => {
        return {
          ...item,
          name_email: item?.billing_address ? (
            <>
              <span style={{ textTransform: language === "en" ? "none" : "capitalize" }}>
                {item?.billing_address?.first_name}{" "}
                {item?.billing_address?.last_name}{" "}
              </span>
              <br />
              {item?.billing_address?.email}
            </>
          ) : (
            item?.email || "-"
          ),
          phone: item?.billing_address ? item?.billing_address?.phone : "-",
          city_postal: item?.billing_address
            ? item?.billing_address?.location +
              ", " +
              item?.billing_address?.postcode
            : "-",
          created: conertDate(item?.created),
          status: item?.status_str,
          energy_consumption: item?.power_consumption
            ? item?.power_consumption.energy_consumption
            : "-",
          payment_status: item?.payment_status_str,
          certificate_status: item?.certificate_status_str,
        };
      });
      setData(list);
      setLoading(false);
    } catch (error) {
      setData([]);
    }
  };
  const onHandleView = (_row) => {
    navigate(`/energy-certificate/${_row.id}`);
  };
  const HandleInvoice = (data) => {
    if (data?.invoice) {
      const iframe = document.createElement("iframe");
      iframe.src = data.invoice;
      iframe.style.width = "100%";
      iframe.style.height = "100%";
      document.body.appendChild(iframe);
    }
  };

  const getServices = async () => {
    try {
      const response = await getApi(`/energy_consumption/add_on_services/`);

      setService(response?.data?.data);
    } catch (error) {}
  };
  useEffect(() => {
    getServices();
  }, []);
  useEffect(() => {
    const applyFilters = () => {
      const finalFilters = {};
      if (pageState) {
        finalFilters.page = pageState;
      }
      if (formData?.form_status) {
        finalFilters.form_status = formData?.form_status?.map(
          (item) => item?.id
        );
      }
      if (formData?.payment_status) {
        finalFilters.payment_status = formData?.payment_status?.map(
          (item) => item?.id
        );
      }
      if (formData?.add_service) {
        finalFilters.add_on_service = formData?.add_service?.map(
          (item) => item?.id
        );
      }
      if (formData?.start_date) {
        finalFilters.from_date = formData?.start_date;
      }
      if (formData?.end_date) {
        finalFilters.to_date = formData?.end_date;
      }
      if (formData?.search) {
        finalFilters.q = formData?.search;
      }
      if (formData?.certificate_status) {
        finalFilters.certificate_status = formData?.certificate_status?.map(
          (item) => item?.id
        );
      }
      getData(finalFilters);
    };

    const timeout = setTimeout(() => {
      applyFilters();
    }, 600);

    return () => clearTimeout(timeout);
    // }
  }, [pageState, formData]);
  useEffect(() => {
    setPageState(1); // Reset pagination to page 1
  }, [formData]);
  const handleChangeINput = (e) => {
    const { name, value } = e.target;

    setFormData({
      ...formData,
      [name]: value ? value : [],
    });
  };

  const handleChangeDate = (date, type) => {
    if (type === "start_date") {
      setFormData((prev) => ({
        ...prev,
        start_date: stringToYYYYMMDD(date),
      }));
    }
    if (type === "end_date") {
      setFormData((prev) => ({
        ...prev,
        end_date: stringToYYYYMMDD(date),
      }));
    }
  };
  const handleDeleteItem = (id, selectName) => {
    setFormData({
      ...formData,
      [selectName]: formData?.[selectName]?.filter((chip) => chip?.id !== id),
    });
  };
  return (
    <div>
      <div
        style={{ textAlign: "end", padding: "0px 8px", marginBottom: "15px" }}
      >
        <TextField
          size="small"
          style={{ width: "40%" }}
          name="search"
          onChange={handleChangeINput} // Handle value changes
          value={formData?.search}
          placeholder={
            language == "de"
              ? consumptionGermText?.search
              : consumptionEngText?.search
          }
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <SearchIcon color="success" />
              </InputAdornment>
            ),
          }}
        />
      </div>

      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        <div style={{ width: "15%" }}>
          <CustomSelectChip
            value={formData?.form_status}
            listArray={form}
            name={"form_status"}
            onChange={handleChangeINput}
            onDelete={handleDeleteItem}
            label={
              language == "de"
                ? consumptionGermText?.form_status
                : consumptionEngText?.form_status
            }
          />
        </div>
        <div style={{ width: "15%" }}>
          <CustomSelectChip
            value={formData?.certificate_status}
            listArray={certificate_status}
            name={"certificate_status"}
            onChange={handleChangeINput}
            onDelete={handleDeleteItem}
            label={
              language == "de"
                ? consumptionGermText?.certificate_status
                : consumptionEngText?.certificate_status
            }
          />
        </div>
        <div style={{ width: "15%" }}>
          <CustomSelectChip
            value={formData?.payment_status}
            listArray={payment}
            name={"payment_status"}
            onChange={handleChangeINput}
            onDelete={handleDeleteItem}
            label={
              language == "de"
                ? consumptionGermText?.payment_status
                : consumptionEngText?.payment_status
            }
          />
        </div>
        <div style={{ width: "15%" }}>
          <CustomSelectChip
            value={formData?.add_service}
            listArray={service}
            name={"add_service"}
            onChange={handleChangeINput}
            onDelete={handleDeleteItem}
            label={
              language == "de"
                ? consumptionGermText?.add_services
                : consumptionEngText?.add_services
            }
          />
        </div>
        <div style={{ width: "15%" }}>
          <DateField
            placeholderText={"Start Date of Creation"}
            onChange={(date) => handleChangeDate(date, "start_date")}
            name="start_date"
            startDate={formData?.start_date}
            max={true}
            minDate={threeYearsBack(3)}
          />
        </div>
        <div style={{ width: "15%" }}>
          <DateField
            placeholderText={"End Date of Creation"}
            onChange={(date) => handleChangeDate(date, "end_date")}
            name="end_date"
            startDate={formData?.end_date}
            max={true}
            minDate={formData?.start_date}
            today={true}
          />
        </div>
      </div>
      <CustomTable
        tableBodys={data}
        tableHeads={language == "de" ? GermTableHeads : EngTableHeads}
        edit={true}
        loading={loading}
        onHandleView={onHandleView}
        HandleInvoice={HandleInvoice}
        icon={true}
      />
      <CustomPagination
        max_pages={max_pages}
        setPageState={setPageState}
        currentPage={pageState}
      />
    </div>
  );
}

export default NeedCertificateTable;
const tabHead = [
  {
    label: "Id",
    id: "id",
    key: false,
    keyName: "",
  },
  {
    label: "Name & Email",
    id: "name_email",
    key: false,
    minWidth: 120,
  },
  {
    label: "Phone Number",
    id: "phone",
    key: false,
    minWidth: 120,
  },
  {
    label: "City, Postal",
    id: "city_postal",
    key: false,
    minWidth: 120,
  },
  {
    label: "Created On",
    id: "created",
    key: false,
    minWidth: 120,
  },
  {
    label: "Form Status",
    id: "status",
    key: false,
    minWidth: 120,
  },
  {
    label: "Energy Certificate",
    id: "certificate_status",
    key: false,
    minWidth: 120,
  },
  {
    label: "Payment Status",
    id: "payment_status",
    key: false,
    minWidth: 120,
  },
  {
    label: "Invoice",
    id: "invoice",
    key: false,
    minWidth: 120,
  },
  {
    label: "",
    id: "collapse",
    key: false,
    minWidth: 20,
  },
];

const dataArray = [
  {
    id: "1822",
    nameEmail: "Keval Ranoliya kevalranoliya@gmail.   ",
    PhoneNumber: "9999999999",
    CityPostal: "Mumbai, 401606",
    CreatedOn: "24th Feb 2024",
    FormStatus: "Submitted",
    EnergyCertificate: "Draft",
    PaymentStatus: "Pending",
  },
  {
    id: "1823",
    nameEmail: "Keval Ranoliya kevalranoliya@gmail.   ",
    PhoneNumber: "9999999999",
    CityPostal: "Mumbai, 401606",
    CreatedOn: "24th Feb 2024",
    FormStatus: "Not Submitted",
    EnergyCertificate: "Issued",
    PaymentStatus: "Pending",
  },
  {
    id: "1824",
    nameEmail: "Keval Ranoliya kevalranoliya@gmail.   ",
    PhoneNumber: "9999999999",
    CityPostal: "Mumbai, 401606",
    CreatedOn: "24th Feb 2024",
    FormStatus: "Submitted",
    EnergyCertificate: "Correction Pending",
    PaymentStatus: "Failed",
  },
  {
    id: "1825",
    nameEmail: "Keval Ranoliya kevalranoliya@gmail.   ",
    PhoneNumber: "9999999999",
    CityPostal: "Mumbai, 401606",
    CreatedOn: "24th Feb 2024",
    FormStatus: "Submitted",
    EnergyCertificate: "Issued Version 2",
    PaymentStatus: "Paid ",
  },
  {
    id: "1822",
    nameEmail: "Keval Ranoliya kevalranoliya@gmail.   ",
    PhoneNumber: "9999999999",
    CityPostal: "Mumbai, 401606",
    CreatedOn: "24th Feb 2024",
    FormStatus: "Submitted",
    EnergyCertificate: "Draft",
    PaymentStatus: "Pending",
  },
  {
    id: "1823",
    nameEmail: "Keval Ranoliya kevalranoliya@gmail.   ",
    PhoneNumber: "9999999999",
    CityPostal: "Mumbai, 401606",
    CreatedOn: "24th Feb 2024",
    FormStatus: "Not Submitted",
    EnergyCertificate: "Issued",
    PaymentStatus: "Pending",
  },
  {
    id: "1824",
    nameEmail: "Keval Ranoliya kevalranoliya@gmail.   ",
    PhoneNumber: "9999999999",
    CityPostal: "Mumbai, 401606",
    CreatedOn: "24th Feb 2024",
    FormStatus: "Submitted",
    EnergyCertificate: "Correction Pending",
    PaymentStatus: "Failed",
  },
  {
    id: "1825",
    nameEmail: "Keval Ranoliya kevalranoliya@gmail.   ",
    PhoneNumber: "9999999999",
    CityPostal: "Mumbai, 401606",
    CreatedOn: "24th Feb 2024",
    FormStatus: "Submitted",
    EnergyCertificate: "Issued Version 2",
    PaymentStatus: "Paid ",
  },
];

export const tableHead = [
  {
    id: "id",
    label: "Id.",
    key: false,
    keyName: "",
  },
  {
    id: "nameEmail",
    label: "Name & Email",
    key: false,
    keyName: "",
    edit: "true",
  },
  {
    id: "PhoneNumber",
    label: "Phone Number",
    key: false,
    keyName: "",
  },
  {
    id: "CityPostal",
    label: "City, Postal",
    key: false,
    keyName: "",
    minWidth: 110,
  },
  {
    id: "CreatedOn",
    label: "Created On",
    key: false,
    keyName: "",
    minWidth: 110,
  },

  {
    id: "FormStatus",
    label: "Form Status",
    key: false,
    keyName: "",
    minWidth: 120,
  },
  {
    id: "EnergyCertificate",
    label: "Energy Certificate",
    key: false,
    keyName: "",
    minWidth: 120,
  },
  {
    id: "PaymentStatus",
    label: "Payment Status ",
    key: false,
    keyName: "",
  },
];
